import { render, staticRenderFns } from "./AdminClassLogin.vue?vue&type=template&id=0bc55d3d&scoped=true"
import script from "./AdminClassLogin.vue?vue&type=script&lang=js"
export * from "./AdminClassLogin.vue?vue&type=script&lang=js"
import style0 from "./AdminClassLogin.vue?vue&type=style&index=0&id=0bc55d3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc55d3d",
  null
  
)

export default component.exports